import { render, staticRenderFns } from "./user-bind-role.vue?vue&type=template&id=682e70f4&scoped=true&"
import script from "./user-bind-role.vue?vue&type=script&lang=js&"
export * from "./user-bind-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682e70f4",
  null
  
)

export default component.exports